import { DocumentModuleEnum } from "shared/enums/document-module-enum";
import { RailDocument } from "shared/models/api/models";
import { DocumentType as IDocumentTypeItem } from 'shared/models/site/document-type';
import { Document } from 'shared/models/site/document';

const isAdditionalRulebookType = (type: string): boolean => [
    "Operating Instructions",
    "Operating Notices"
].filter(x => x == type).length > 0;

// Rail documents also include operating notices and instructions.  Define some global filters here so that they can easily be redefined.  
export const isRulebookRailDocument = (x: RailDocument): boolean => (x.moduleId === DocumentModuleEnum.Rulebook || isAdditionalRulebookType(x.type));
export const isRulebookDocument = (x: Document): boolean => (x.documentModule === DocumentModuleEnum.Rulebook || isAdditionalRulebookType(x.typeLabel || ''));
export const isRuleBookDocumentType = (x: IDocumentTypeItem): boolean => x.documentModule === DocumentModuleEnum.Rulebook || isAdditionalRulebookType(x.label);